const data = [
    {
        id: 1,
        question: 'Explain "hoisting"',
        url: 'https://frontend-stuff.com/blog/hoisting/',
        status: 0
    },
    {
        id: 2,
        question: 'What is the difference between == and === ?',
        url: '',
        status: 0
    },
    {
        id: 3,
        question: 'What is a closure, and how/why would you use one?',
        url: '',
        status: 0
    },
    {
        id: 4,
        question: 'What is the difference between while and do-while loops in JavaScript?',
        url: '',
        status: 0
    },
    {
        id: 5,
        question: 'What are the benefits of using spread syntax and how is it different from rest syntax?',
        url: '',
        status: 0
    },
    {
        id: 6,
        question: `What's a typical use case for anonymous functions?`,
        url: '',
        status: 0
    },
    {
        id: 7,
        question: `What's a typical use case for anonymous functions?`,
        url: '',
        status: 0
    },
    {
        id: 8,
        question: `What is a promise? Where and how would you use promise?`,
        url: '',
        status: 0
    },
    {
        id: 9,
        question: `How can you share code between files?`,
        url: '',
        status: 0
    },
    {
        id: 10,
        question: `What are the differences between variables created using let, var or const?`,
        url: '',
        status: 0
    },
    {
        id: 11,
        question: `Explain the difference between synchronous and asynchronous functions.`,
        url: '',
        status: 0
    },
    {
        id: 12,
        question: `Can you offer a use case for the new arrow => function syntax? How does this new syntax differ from other functions?`,
        url: '',
        status: 0
    },
    {
        id: 13,
        question: `Why is it called a Ternary operator, what does the word "Ternary" indicate?`,
        url: '',
        status: 0
    },
    {
        id: 14,
        question: `What is the definition of a higher-order function?`,
        url: '',
        status: 0
    },
    {
        id: 15,
        question: `Can you give an example for destructuring an object or an array?`,
        url: '',
        status: 0
    },


]

export default data;